module.exports = __webpack_public_path__ + "media/images/vendors/verndors_small-92cb68a35e22798ae7ca4b2b7b7ee83e.png";